import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import Footer from '../../components/Footer';
import FormSpinner from '../../components/FormSpinner';
import Header from '../../components/Header';
import { getTreatment, loadSplitIo } from '../../utils/ab';
import {
    getFromLocalStorage,
    setToLocalStorage,
} from '../../utils/localstorage';

const SPLITIO_SIGNUP_EXP = 'nwa-signup-experiments-r1-2';
const LS_KEY = 'ab-anon-user-v3';
const CONTROL_VARIANT = 'signup-0';
const VALID_VARIANTS = new Set([CONTROL_VARIANT, 'signup-1']);

const getOrCreateAnonymousSplitUserId = () => {
    let userId = getFromLocalStorage(LS_KEY);

    if (!userId) {
        userId = `anon-user-${Math.random().toString(36).slice(2, 12)}`;
        setToLocalStorage(LS_KEY, userId);
    }

    return userId;
};

const getVariant = () => {
    const treatment = getTreatment(SPLITIO_SIGNUP_EXP);

    if (
        treatment === 'control' ||
        treatment === 'off' ||
        !VALID_VARIANTS.has(treatment)
    ) {
        return CONTROL_VARIANT;
    }

    return treatment;
};

const SignUpExperimentLandingPage = () => {
    const navigate = useNavigate();
    const search = useLocation().search;

    useEffect(() => {
        if (window.Cypress) {
            navigate(`../${CONTROL_VARIANT}${search}`);
            return;
        }

        const userId = getOrCreateAnonymousSplitUserId();

        return loadSplitIo(userId, () => {
            navigate(`../${getVariant()}${search}`);
        });
    }, [navigate, search]);

    return (
        <section className='eh-page-sign-up'>
            <Header />
            <FormSpinner />
            <Footer />
        </section>
    );
};

export default SignUpExperimentLandingPage;
